import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/feature/ScrollToTop';
import SEOHelmet from '@/components/base/SEOHelmet';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGridSection from './components/CategoryGrid';
import HotArticlesSection from './components/HotArticles';
import CooperationSection from './components/CooperationSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const organizationSchema = {
    name: '国产传媒',
    url: 'https://www.guochuanmedia.com',
    description: '国产传媒是专注本土内容创作与传播的核心平台，汇聚优质国产影视、资讯、娱乐内容。',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressCountry: 'CN',
      streetAddress: '朝阳区建国路88号',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
    },
  };

  const websiteSchema = {
    name: '国产传媒',
    url: 'https://www.guochuanmedia.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.guochuanmedia.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    name: '国产传媒·权威内容平台官方入口',
    url: 'https://www.guochuanmedia.com',
    description: '国产传媒是专注本土内容创作与传播的核心平台，汇聚优质国产影视、资讯、娱乐内容，助力品牌与创作者实现高效传播。',
  };

  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SEOHelmet
        title="权威内容平台官方入口"
        description="国产传媒是专注本土内容创作与传播的核心平台，汇聚优质国产影视、资讯、娱乐内容，助力品牌与创作者实现高效传播。立即了解国产传媒的完整服务体系与合作方案。"
        keywords="国产传媒,国产传媒平台,国产传媒内容合作,国产影视传媒,本土传媒运营,国产传媒广告投放,传媒内容分发"
        canonicalUrl="https://www.guochuanmedia.com/"
        ogTitle="国产传媒·权威内容平台官方入口"
        ogDescription="国产传媒是专注本土内容创作与传播的核心平台，汇聚优质国产影视、资讯、娱乐内容，助力品牌与创作者实现高效传播。"
      />

      <Navbar transparent />
      <main>
        <HeroSection />
        <CategoryGridSection />
        <HotArticlesSection />
        <CooperationSection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </>
  );
}